module.exports = __webpack_public_path__ + "img/logo.024138a.png";